export const allKeyArgs = (args: object, excluded: string[] = []): (string | string[])[] => {
  const keys = Object.keys(args)
  if (!excluded.length) return keys
  return keys.filter((arg) => !excluded.includes(arg))
}
